export const h2Account = '9fc33b12-0a89-58c2-b88c-2c5399d1a2ba';
